import React from "react";
import Card from "../card/song_card";
import "../../css/top100.scss";

const Top100 = ({ data }) => {
  return (
    <div className="top100_main">
      <div className="main_banner">
        <span>TOP</span>
        <svg width="625" height="166" viewBox="0 0 625 166">
          <defs>
            <linearGradient
              id="csl6gbytxb"
              x1="0%"
              x2="102%"
              y1="49.434%"
              y2="50.578%"
            >
              <stop offset="0%" stop-color="#3023AE"></stop>
              <stop offset="100%" stop-color="#C86DD7"></stop>
            </linearGradient>
            <linearGradient
              id="nhmksuo1gc"
              x1="0%"
              x2="102%"
              y1="26.937%"
              y2="73.525%"
            >
              <stop offset="0%" stop-color="#3023AE"></stop>
              <stop offset="100%" stop-color="#C86DD7"></stop>
            </linearGradient>
            <path
              id="dxhld9pu1a"
              d="M7.99 88.712V74.768h3.966v-3.09H.566v3.09h3.992v13.944h3.431zm74.837.316c2.604 0 4.721-.851 6.4-2.53 1.63-1.68 2.458-3.772 2.458-6.303 0-2.507-.827-4.6-2.458-6.279-1.679-1.703-3.82-2.555-6.4-2.555-2.58 0-4.721.852-6.4 2.555-1.63 1.68-2.458 3.772-2.458 6.279 0 2.53.827 4.623 2.458 6.302 1.679 1.68 3.796 2.531 6.4 2.531zm0-3.212c-1.533 0-2.799-.535-3.796-1.582-.998-1.046-1.485-2.409-1.485-4.04 0-1.605.487-2.944 1.485-4.015.997-1.07 2.263-1.606 3.796-1.606s2.799.536 3.796 1.606c.998 1.071 1.485 2.41 1.485 4.016 0 1.63-.487 2.993-1.485 4.04-.997 1.046-2.263 1.581-3.796 1.581zm76.128 2.896v-6.351h2.02c1.606 0 2.944-.512 3.99-1.51 1.047-.997 1.582-2.287 1.582-3.869 0-1.606-.51-2.895-1.557-3.869-1.022-.949-2.36-1.436-4.04-1.436h-5.427v17.035h3.432zm1.533-9.32h-1.533v-4.746h1.582c.73 0 1.314.22 1.776.633.462.438.706.998.706 1.703 0 .706-.244 1.29-.706 1.753-.462.438-1.07.657-1.825.657z"
            ></path>
          </defs>
          <g fill="none" fill-rule="evenodd" opacity="0.653">
            <g>
              <g>
                <g>
                  <g
                    fill-rule="nonzero"
                    transform="translate(-504 -92) translate(239) translate(265 92)"
                  >
                    <use fill="#257eff"></use>
                  </g>
                  <path
                    d="M434 45H625V124H434z"
                    transform="translate(-504 -92) translate(239) translate(265 92)"
                  ></path>
                  <path
                    fill="#257eff
                    "
                    d="M368.977 146.84c-32.595 0-59.113-26.5-59.113-59.073l-.001-.016.001-.066c0-21.715-17.679-39.382-39.409-39.382-14.823 0-27.756 8.225-34.483 20.343V56.073c8.862-9.649 21.338-15.154 34.483-15.154 25.805 0 46.798 20.98 46.798 46.766h.009c-.001.028-.009.054-.009.082 0 28.501 23.204 51.689 51.724 51.689 28.521 0 51.725-23.188 51.725-51.689 0-28.5-23.204-51.688-51.725-51.688-16.88 0-32.297 7.978-42.01 21.53-1.25-2.335-2.639-4.585-4.159-6.737 11.292-14.118 28.018-22.177 46.17-22.177 32.595 0 59.113 26.5 59.113 59.072 0 32.573-26.518 59.073-59.114 59.073m-98.522-24.696c-19.014 0-34.483-15.458-34.483-34.459 0-19 15.47-34.46 34.483-34.46 19.014 0 34.483 15.46 34.483 34.46 0 19.001-15.469 34.46-34.483 34.46m98.522-68.837c19.014 0 34.483 15.459 34.483 34.46 0 19-15.469 34.458-34.483 34.458-19.013 0-34.482-15.458-34.482-34.459 0-19 15.469-34.459 34.482-34.459m-98.522-24.696c32.595 0 59.114 26.5 59.114 59.073h.001l-.001.082c0 21.715 17.678 39.382 39.408 39.382s39.41-17.667 39.41-39.382c0-21.715-17.68-39.382-39.41-39.382-16.305 0-30.33 9.948-36.315 24.09-.82-3.351-1.901-6.6-3.227-9.721C338.079 49.116 352.785 41 368.977 41c25.805 0 46.799 20.98 46.799 46.766 0 25.787-20.994 46.766-46.799 46.766-25.804 0-46.798-20.979-46.798-46.766 0-.028-.007-.054-.008-.082h.008c0-28.5-23.203-51.689-51.724-51.689-12.814 0-25.053 4.733-34.483 13.165v-9.44c10.1-7.268 21.982-11.109 34.483-11.109m49.278 18.248c-11.756-14.146-29.482-23.17-49.278-23.17-12.374 0-24.189 3.467-34.483 10.069V2.545c0-.85-.44-1.641-1.163-2.09-.723-.45-1.627-.494-2.39-.117l-40.887 20.184c-1.22.602-1.72 2.078-1.118 3.296.603 1.22 2.08 1.72 3.3 1.117l37.332-18.428v81.26c0 .01.003.018.003.028.06 21.665 17.713 39.272 39.406 39.272 16.306 0 30.33-9.947 36.316-24.089.82 3.35 1.901 6.6 3.227 9.72-8.644 13.638-23.351 21.753-39.543 21.753-25.804 0-46.798-20.979-46.798-46.766v-65.39c0-.853-.442-1.645-1.168-2.094-.726-.449-1.633-.489-2.396-.107L191.52 34.369c-1.217.608-1.71 2.087-1.101 3.303.608 1.216 2.088 1.708 3.304 1.1l25.007-12.495v63.364c0 .182.023.36.061.531 1.303 27.35 23.977 49.202 51.663 49.202 16.88 0 32.297-7.98 42.01-21.53 1.25 2.334 2.639 4.584 4.158 6.735-11.29 14.116-28.025 22.179-46.168 22.179-32.595 0-59.113-26.5-59.113-59.073V41.001c0-.853-.442-1.645-1.169-2.093-.725-.449-1.632-.49-2.396-.108l-16.748 8.369c-1.217.607-1.71 2.086-1.102 3.302.608 1.216 2.088 1.708 3.304 1.1l13.185-6.587v117.914c0 1.36 1.103 2.461 2.463 2.461s2.463-1.102 2.463-2.461v-50.606c1.897 4.534 4.302 8.805 7.143 12.741v37.865c0 1.36 1.103 2.461 2.463 2.461s2.463-1.102 2.463-2.461v-31.842c2.137 2.313 4.443 4.468 6.896 6.447v25.395c0 1.36 1.103 2.461 2.463 2.461s2.463-1.102 2.463-2.461v-21.794c10.112 6.68 22.22 10.577 35.222 10.577 19.249 0 37.029-8.38 49.245-23.089 11.755 14.146 29.48 23.17 49.277 23.17 35.312 0 64.04-28.708 64.04-63.995s-28.728-63.995-64.04-63.995c-19.257 0-37.03 8.378-49.244 23.088z"
                    transform="translate(-504 -92) translate(239) translate(265 92)"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <h1 className="catego_title">Nhạc Việt Nam</h1>
      <div className="list_card">
        <Card playlist={data} />
      </div>
      <h1 className="catego_title">Nhạc US-UK</h1>
      <div className="list_card">
        <Card playlist={data} />
        <Card playlist={data} />
      </div>
      <h1 className="catego_title">Nhạc KPOP</h1>
      <div className="list_card">
        <Card playlist={data} />
      </div>
      <h1 className="catego_title">Nhạc Châu Á</h1>
      <div className="list_card">
        <Card playlist={data} />
      </div>
    </div>
  );
};

export default Top100;
